import { useDropMedia } from 'root/src/client/v2/drop/hooks/useDropMedia';
import { useRecordId } from 'root/src/client/v2/common/hooks/useRecordId';
import { RaceForRewardsPlayers } from 'root/src/client/v2/drop/features/RaceForRewards/RaceForRewardsPlayers';
import { RaceForRewardsHeader } from 'root/src/client/v2/drop/features/RaceForRewards/RaceForRewardsHeader';
export function RaceForRewards() {
    const recordId = useRecordId();
    if (!recordId) {
        return null;
    }
    const { data: media, isLoading, } = useDropMedia(recordId);
    if (typeof media === 'undefined' || isLoading || media.length === 0) {
        return null;
    }
    return (<div className="bg-black p-10">
			<RaceForRewardsHeader />
			<RaceForRewardsPlayers media={media}/>
		</div>);
}
